var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadchart)?_c('apexchart',{attrs:{"type":_vm.type,"height":"350","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }